export default "__VITE_ASSET__DMDYfPr6__"